import { UIContainer, PlaybackToggleOverlay, BufferingOverlay, CastStatusOverlay, SubtitleOverlay, ErrorMessageOverlay, UIManager, PlaybackToggleButton, PlayerUtils } from 'bitmovin-player-ui';
import { createMiddleButtons } from './components/buttons';
import { createPlayNextScreen } from './components/playnext';
import { createSettingsPanel } from './components/settingspanel';
import { createCTABar } from './components/ctabar';
import { createTopBar } from './components/topbar';
import { createControlBar } from './components/controlbar';
import { createAudioControlBar } from './components/audio/controlbar';
import { createTitleBar } from './components/titlebar';
import { localizeKey } from '../js/utilities/utilities.locale';
import { localizationConfig } from '../js/settings/localization';
import { NpoPlayerUIVariants } from '../types/interfaces';
import { createVerticalVideoControlBar } from './components/verticalvideo/controlbar';
import { DEFAULT_UI_DELAY, PREVENT_UI_DELAY } from '../services/npoPlayerAPI/contants';
export function createUIContainer(playerContext, player, variant) {
    const cssClassArray = ['npo-player'];
    const npoPlayer = playerContext.npoplayer;
    const container = npoPlayer.container;
    let uiDelay = DEFAULT_UI_DELAY;
    container.dataset.npoPlayerVersion = npoPlayer.version;
    container.classList.remove('bitmovinplayer-audio-container');
    switch (variant) {
        case NpoPlayerUIVariants.DEFAULT: {
            uiDelay = DEFAULT_UI_DELAY;
            break;
        }
        case NpoPlayerUIVariants.AD: {
            uiDelay = PREVENT_UI_DELAY;
            cssClassArray.push('ster-ad');
            break;
        }
        case NpoPlayerUIVariants.AUDIO: {
            uiDelay = PREVENT_UI_DELAY;
            container.classList.add('bitmovinplayer-audio-container');
            cssClassArray.push('audio');
            break;
        }
        case NpoPlayerUIVariants.VERTICAL: {
            uiDelay = DEFAULT_UI_DELAY;
            cssClassArray.push('vertical-video');
            npoPlayer.player?.setAspectRatio('9:16');
            break;
        }
    }
    const middleButtons = createMiddleButtons(playerContext);
    const playNextScreen = createPlayNextScreen(player, npoPlayer);
    const settingsPanel = createSettingsPanel(npoPlayer);
    const ctaBar = createCTABar(player, npoPlayer, variant);
    const topBar = createTopBar(playerContext);
    const controlBar = createControlBar(playerContext);
    const titleBar = createTitleBar(npoPlayer);
    const playbackToggleOverlay = new PlaybackToggleOverlay();
    const audioControlbar = createAudioControlBar(npoPlayer);
    const bufferingOverlay = new BufferingOverlay();
    const verticalVideoControlBar = createVerticalVideoControlBar(playerContext);
    const errorMessageOverlay = new ErrorMessageOverlay();
    const castStatusOverlay = new CastStatusOverlay();
    npoPlayer.uiComponents.errorMessageOverlay = errorMessageOverlay;
    const defaultVideoComponents = [settingsPanel, new SubtitleOverlay(), bufferingOverlay, playbackToggleOverlay];
    const components = [];
    if (variant === NpoPlayerUIVariants.DEFAULT) {
        components.push(...defaultVideoComponents, castStatusOverlay, middleButtons, playNextScreen, controlBar, ctaBar, titleBar, topBar);
    }
    if (variant === NpoPlayerUIVariants.VERTICAL) {
        components.push(...defaultVideoComponents, verticalVideoControlBar, titleBar);
    }
    if (variant === NpoPlayerUIVariants.AUDIO) {
        components.push(new PlaybackToggleButton(), audioControlbar, titleBar);
    }
    if (variant === NpoPlayerUIVariants.AD) {
        components.push(...defaultVideoComponents, castStatusOverlay, middleButtons, controlBar, ctaBar);
    }
    UIManager.setLocalizationConfig(localizationConfig);
    const ariaLabelKey = variant === NpoPlayerUIVariants.AUDIO ? 'audioPlayer' : 'videoPlayer';
    return new UIContainer({
        components: [...components, errorMessageOverlay],
        cssClasses: cssClassArray,
        ariaLabel: localizeKey(ariaLabelKey),
        hideDelay: uiDelay,
        hidePlayerStateExceptions: [PlayerUtils.PlayerState.Paused]
    });
}
